import Immutable from 'immutable';

export default Immutable.fromJS({
  studySet : {
    id    : null,
    title : null,
  },
});
